import { Box, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Icon from '@/assets/images/Save.svg'

type PlanInterval = 'month' | 'year'

interface PlanToggleProps {
  selectedPlan: PlanInterval
  onChange: (val: PlanInterval) => void
}

const PlanToggle: React.FC<PlanToggleProps> = ({ selectedPlan, onChange }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'plans' })

  return (
    <Box display="flex" justifyContent="center" mt={5}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="flex-start"
        py="0.25rem"
        px="0.5rem"
        bgcolor="rgb(30,30,30)"
        borderRadius="0.5rem"
      >
        {['month', 'year'].map((type) => {
          const isSelected = selectedPlan === type
          const isYear = type === 'year'

          return (
            <Box
              key={type}
              onClick={() => onChange(type as PlanInterval)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                px: '1.25rem',
                py: '0.5625rem',
                gap: '0.5rem',
                cursor: 'pointer',
                borderRadius: '0.5rem',
                border: isSelected ? '1px solid #FF95D4' : 'none',
                background: isSelected ? '#1E1E1E' : 'transparent',
                color: '#fff',
              }}
            >
              <Typography fontSize="16px" fontWeight={500}>
                {type === 'month' ? t('monthly') : t('yearly')}
              </Typography>
              {isYear && (
                <>
                  <img src={Icon} alt="save" />
                  <Typography
                    sx={{
                      fontWeight: 500,
                      background:
                        'linear-gradient(290deg, #C5A5FF 0%, #FFA1A3 100%)',
                      backgroundClip: 'text',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      fontSize: '14px',
                    }}
                  >
                    {t('save')} 18%
                  </Typography>
                </>
              )}
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}

export default PlanToggle
